import { useDispatch } from "react-redux";
import { Card, CardContent } from "@/components/ui/library/card";
import { ChildDetailsHeader } from "./ChildDetailsHeader";
import { Separator } from "@/components/ui/separator";
import { ChoiceInfo } from "./ChoiceInfo";
import StatusSection from "./StatusSection";
import DocumentSection from "./DocumentSection";
import AssingnedUsers from "./AssingnedUsers";
import { CollabedBadge } from "../../../../components/components";
import {
  setCurrentDetailChild,
  setIsStageViewOverride,
} from "@/features/leads/stores/childSlice";
import { useAppSelector } from "@/stores/hook";

export default function ChildDetails() {
  const dispatch = useDispatch();
  const { currentDetailChild } = useAppSelector(
    (state) => state.childFunctional
  );

  const handleBackClick = () => {
    dispatch(setIsStageViewOverride(false));
    dispatch(setCurrentDetailChild({}));
  };

  return (
    <Card className="border-[var(--color-black-1)] rounded-[16px] shadow-none  py-0 relative">
      <CardContent className="px-4 py-4 gap-4 flex flex-col">
        <ChildDetailsHeader
          childName={(currentDetailChild as any)?.name}
          onBackClick={handleBackClick}
        />
        <Separator />

        <ChoiceInfo child={currentDetailChild as any} />
        <StatusSection child={currentDetailChild as any} />
        <DocumentSection />
        <AssingnedUsers child={currentDetailChild as any} />
      </CardContent>

      {/* Collabed Badge */}
      <CollabedBadge position="right" />
    </Card>
  );
}
